// @flow weak

import _ from 'lodash/fp';
import React from 'react';
import {connect} from 'react-redux';
import {BrowserRouter, NavLink, Route, Redirect, Switch} from 'react-router-dom';
import ApartmentContainer from '../ApartmentContainer/ApartmentContainer';
import ApartmentConfigContainer from '../ApartmentConfigContainer/ApartmentConfigContainer';
import UsersContainer from '../UsersContainer/UsersContainer';
import UserContainer from '../UserContainer/UserContainer';
import WorkerTypesContainer from '../WorkerTypesContainer/WorkerTypesContainer';
import WorkerTypeContainer from '../WorkerTypeContainer/WorkerTypeContainer';
import ProjectCreationContainer from '../ProjectCreationContainer/ProjectCreationContainer';
import ProjectEditingContainer from '../ProjectEditingContainer/ProjectEditingContainer';
import ProjectsContainer from '../ProjectsContainer/ProjectsContainer';
import ProductTypesContainer from '../ProductTypesContainer/ProductTypesContainer';
import ProductTypeContainer from '../ProductTypeContainer/ProductTypeContainer';
import ProductContainer from '../ProductContainer/ProductContainer';
import ProductsContainer from '../ProductsContainer/ProductsContainer';
import RoomTypesContainer from '../RoomTypesContainer/RoomTypesContainer';
import RoomTypeContainer from '../RoomTypeContainer/RoomTypeContainer';
import DeviationsContainer from '../DeviationsContainer/DeviationsContainer';
import ExportsContainer from '../ExportsContainer/ExportsContainer';
import SalesContainer from '../SalesContainer/SalesContainer';
import PurchaseOrderReportContainer from '../PurchaseOrderReportContainer/PurchaseOrderReportContainer';
import SiteManagerReportContainer from '../SiteManagerReportContainer/SiteManagerReportContainer';
import DeviationContainer from '../DeviationContainer/DeviationContainer';
import SuppliersContainer from '../SuppliersContainer/SuppliersContainer';
import SupplierContainer from '../SupplierContainer/SupplierContainer';
import AdminNavbar from '../../components/AdminNavbar/AdminNavbar';
import {logout} from '../../actions/auth';
import OrdersContainer from '../OrdersContainer/OrdersContainer';
import OrderContainer from '../OrderContainer/OrderContainer';
import CustomRowContainer from '../CustomRowContainer/CustomRowContainer';
import AdminCustomerContainer from '../AdminCustomerContainer/AdminCustomerContainer';
import PurchaseOrderContainer from '../PurchaseOrderContainer/PurchaseOrderContainer';
import PurchaseOrdersContainer from '../PurchaseOrdersContainer/PurchaseOrdersContainer';
import ConfigTemplatesContainer from '../ConfigTemplatesContainer/ConfigTemplatesContainer';
import ConfigTemplateContainer from '../ConfigTemplateContainer/ConfigTemplateContainer';
import RoomTemplatesContainer from '../RoomTemplatesContainer/RoomTemplatesContainer';
import RoomTemplateContainer from '../RoomTemplateContainer/RoomTemplateContainer';
import './AdminContainer.css';

export type Props = {
  location: { pathname: string },
  onLogoutClick: Function,
};

const AdminContainer = ({location: {pathname = ''} = {}, onLogoutClick}: Props) => (
  <BrowserRouter>
    <div className="AdminContainer">
      <AdminNavbar onLogoutClick={onLogoutClick} />
      <div className="row content">
        <div className="shrink column">
          <div className="Sidebar">
            <div className="Sidebar-content">
              <div className="AdminMenu">
                <NavLink
                  to={`${pathname}/projects`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Projekt
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/orders`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Beställningar
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/purchaseorders`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Inköp
                  </div>
                </NavLink>
                <hr/>
                <NavLink
                  to={`${pathname}/products`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Produkter
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/productTypes`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Produkttyper
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/workertypes`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Yrkeskategorier
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/roomTypes`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Rumstyper
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/suppliers`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Leverantörer
                  </div>
                </NavLink>
                <hr/>
                <NavLink
                  to={`${pathname}/configtemplates`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Konfigurationsmallar
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/roomtemplates`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Rumsmallar
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/users`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Användare
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/deviations`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Avvikelser
                  </div>
                </NavLink>
                <hr/>
                <NavLink
                  to={`${pathname}/exports`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Produktrapport
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/sales`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Ekonomirapport
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/purchasereport`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Inköpsrapport
                  </div>
                </NavLink>
                <NavLink
                  to={`${pathname}/sitemanagerreport`}
                  className="AdminMenu-item"
                  activeClassName="active">
                  <div className="MenuItem-label">
                    Platschefsrapport
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="small-12 large-expand column flex">
          <Switch>
            <Route
              path={`${pathname}/apartments/:id(\\d+)`}
              render={({match: {params}}) => (
                <ApartmentContainer
                  params={params}
                  resourcePath={`${pathname}/apartments`}
                  projectPath={`${pathname}/projects/${params.projectId}`}/>
              )} />
            <Route
              path={`${pathname}/configtemplates`}
              exact={true}
              component={ConfigTemplatesContainer} />
            <Route
              path={`${pathname}/configtemplates/new`}
              exact={true}
              render={({match: {params}}) => (
                <ConfigTemplateContainer
                  params={params}
                  prevPath={`${pathname}/configtemplates`} />
              )} />
            <Route
              path={`${pathname}/configtemplates/:id(\\d+)`}
              render={({match: {params}}) => (
                <ConfigTemplateContainer
                  params={params}
                  prevPath={`${pathname}/configtemplates`} />
              )} />
            <Route
              path={`${pathname}/roomtemplates`}
              exact={true}
              component={RoomTemplatesContainer} />
            <Route
              path={`${pathname}/roomtemplates/new`}
              exact={true}
              render={({match: {params}}) => (
                <RoomTemplateContainer
                  params={params}
                  prevPath={`${pathname}/roomtemplates`} />
              )} />
            <Route
              path={`${pathname}/roomtemplates/:id(\\d+)`}
              render={({match: {params}}) => (
                <RoomTemplateContainer
                  params={params}
                  prevPath={`${pathname}/roomtemplates`} />
              )} />
            <Route
              path={`${pathname}/users`}
              exact={true}
              component={UsersContainer} />
            <Route
              path={`${pathname}/users/new`}
              exact={true}
              render={({match: {params}}) => (
                <UserContainer
                  params={params}
                  prevPath={`${pathname}/users`} />
              )} />
            <Route
              path={`${pathname}/users/:id(\\d+)`}
              render={({match: {params}}) => (
                <UserContainer
                  params={params}
                  prevPath={`${pathname}/users`} />
              )} />
            <Route
              path={`${pathname}/projects`}
              exact={true}
              component={ProjectsContainer} />
            <Route
              path={`${pathname}/projects/new`}
              exact={true}
              render={({match: {params}}) => (
                <ProjectCreationContainer
                  params={params}
                  prevPath={`${pathname}/projects`} />
              )} />
            <Route
              path={`${pathname}/projects/:projectId(\\d+)/apartments/new`}
              render={({match: {params}}) => (
                <ApartmentContainer
                  params={params}
                  projectId={_.toInteger(params.projectId)}
                  resourcePath={`${pathname}/projects/${params.projectId}/apartments`}
                  projectPath={`${pathname}/projects/${params.projectId}`}/>
              )} />
            <Route
              path={`${pathname}/projects/:projectId(\\d+)/apartments/:id(\\d+)`}
              render={({match: {params}}) => (
                <ApartmentContainer
                  params={params}
                  orderPath={`${pathname}/orders`}
                  resourcePath={`${pathname}/projects/${params.projectId}/apartments`}
                  projectPath={`${pathname}/projects/${params.projectId}`}/>
              )} />
            <Route
              path={`${pathname}/projects/:projectId(\\d+)/apartmentconfigurations/new`}
              render={({match: {params}}) => (
                <ApartmentConfigContainer
                  params={params}
                  projectId={params.projectId}
                  resourcePath={`${pathname}/projects/${params.projectId}/apartmentconfigurations`} />
              )} />
            <Route
              path={`${pathname}/projects/:projectId(\\d+)/apartmentconfigurations/:id(\\d+)`}
              render={({match: {params}}) => (
                <ApartmentConfigContainer
                  params={params}
                  prevPath={`${pathname}/projects/${params.projectId}`}
                  resourcePath={`${pathname}/projects/${params.projectId}/apartmentconfigurations`} />
              )} />
            <Route
              path={`${pathname}/projects/:id(\\d+)`}
              render={({match: {params}}) => (
                <ProjectEditingContainer
                  params={params}
                  prevPath={`${pathname}/projects`} />
              )} />
            <Route
              path={`${pathname}/productTypes`}
              exact={true}
              component={ProductTypesContainer} />
            <Route
              path={`${pathname}/productTypes/new`}
              exact={true}
              render={({match: {params}}) => (
                <ProductTypeContainer
                  params={params}
                  prevPath={`${pathname}/productTypes`} />
              )} />
            <Route
              path={`${pathname}/productTypes/:id(\\d+)`}
              render={({match: {params}}) => (
                <ProductTypeContainer
                  params={params}
                  prevPath={`${pathname}/productTypes`} />
              )} />
            <Route
              path={`${pathname}/products`}
              exact={true}
              component={ProductsContainer} />
            <Route
              path={`${pathname}/products/new`}
              exact={true}
              render={({match: {params}}) => (
                <ProductContainer
                  key={'new'}
                  params={params}
                  copy={false}
                  resourcePath={`${pathname}/products`} />
              )} />
            <Route
              path={`${pathname}/products/:id(\\d+)/variants/:variantId(\\d+)`}
              render={({match: {params}}) => (
                <ProductContainer
                  key={'notcopy'}
                  params={params}
                  copy={false}
                  resourcePath={`${pathname}/products`} />
              )} />
            <Route
              path={`${pathname}/products/:id(\\d+)/copy`}
              render={({match: {params}}) => {
                return <ProductContainer
                  key={'copy'}
                  params={{...params}}
                  copy={true}
                  resourcePath={`${pathname}/products`} />;
              }} />
            <Route
              path={`${pathname}/products/:id(\\d+)`}
              render={({match: {params}}) => (
                <ProductContainer
                  key={'notcopy'}
                  params={params}
                  copy={false}
                  resourcePath={`${pathname}/products`} />
              )} />
            <Route
              path={`${pathname}/workertypes`}
              exact={true}
              component={WorkerTypesContainer} />
            <Route
              path={`${pathname}/workertypes/new`}
              exact={true}
              render={({match: {params}}) => (
                <WorkerTypeContainer
                  params={params}
                  prevPath={`${pathname}/workertypes`} />
              )} />
            <Route
              path={`${pathname}/workertypes/:id(\\d+)`}
              render={({match: {params}}) => (
                <WorkerTypeContainer
                  params={params}
                  prevPath={`${pathname}/workertypes`} />
              )} />
            <Route
              path={`${pathname}/roomTypes`}
              exact={true}
              component={RoomTypesContainer} />
            <Route
              path={`${pathname}/roomTypes/new`}
              exact={true}
              render={({match: {params}}) => (
                <RoomTypeContainer
                  params={params}
                  prevPath={`${pathname}/roomTypes`} />
              )} />
            <Route
              path={`${pathname}/roomTypes/:id(\\d+)`}
              render={({match: {params}}) => (
                <RoomTypeContainer
                  params={params}
                  prevPath={`${pathname}/roomTypes`} />
              )} />
            <Route
              path={`${pathname}/deviations`}
              exact={true}
              component={DeviationsContainer} />
            <Route
              path={`${pathname}/deviations/new`}
              exact={true}
              render={({match: {params}}) => (
                <DeviationContainer
                  params={params}
                  prevPath={`${pathname}/deviations`} />
              )} />
            <Route
              path={`${pathname}/deviations/:id(\\d+)`}
              render={({match: {params}}) => (
                <DeviationContainer
                  params={params}
                  prevPath={`${pathname}/deviations`} />
              )} />
            <Route
              path={`${pathname}/suppliers`}
              exact={true}
              component={SuppliersContainer} />
            <Route
              path={`${pathname}/suppliers/new`}
              exact={true}
              render={({match: {params}}) => (
                <SupplierContainer
                  params={params}
                  prevPath={`${pathname}/suppliers`} />
              )} />
            <Route
              path={`${pathname}/suppliers/:id(\\d+)`}
              render={({match: {params}}) => (
                <SupplierContainer
                  params={params}
                  prevPath={`${pathname}/suppliers`} />
              )} />
            <Route
              path={`${pathname}/orders`}
              exact={true}
              component={() => <OrdersContainer readonly={false} />} />
            <Route
              path={`${pathname}/orders/new`}
              exact={true}
              render={({match: {params}}) => (
                <OrderContainer
                  params={params}
                  prevPath={`${pathname}/orders`} />
              )} />
            <Route
              path={`${pathname}/orders/:orderId(\\d+)/customrows/new`}
              render={({match: {params}}) => (
                <CustomRowContainer
                  params={params}
                  orderId={_.toInteger(params.orderId)}
                  prevPath={`${pathname}/orders/${params.orderId}`}
                  resourcePath={`${pathname}/orders/${params.orderId}/customrows`}/>
              )} />
            <Route
              path={`${pathname}/orders/:orderId(\\d+)/customrows/:id(\\d+)`}
              render={({match: {params}}) => (
                <CustomRowContainer
                  params={params}
                  orderId={_.toInteger(params.orderId)}
                  prevPath={`${pathname}/orders/${params.orderId}`}
                  resourcePath={`${pathname}/orders/${params.orderId}/customrows`}/>
              )} />
            <Route
              path={`${pathname}/orders/:orderId(\\d+)/customerorder`}
              render={({match: {params}}) => (
                <AdminCustomerContainer orderId={params.orderId} />
              )} />
            <Route
              path={`${pathname}/orders/:id(\\d+)`}
              render={({match: {params}}) => (
                <OrderContainer
                  params={params}
                  prevPath={`${pathname}/orders`} />
              )} />
            <Route
              path={`${pathname}/purchaseorders`}
              exact={true}
              component={PurchaseOrdersContainer} />
            <Route
              path={`${pathname}/purchaseorders/:id(\\d+)`}
              render={({match: {params}}) => (
                <PurchaseOrderContainer
                  params={params}
                  prevPath={`${pathname}/purchaseorders`} />
              )} />
            <Route
              path={`${pathname}/exports`}
              exact={true}
              component={ExportsContainer} />
            <Route
              path={`${pathname}/sales`}
              exact={true}
              component={SalesContainer} />
            <Route
              path={`${pathname}/purchasereport`}
              exact={true}
              component={PurchaseOrderReportContainer} />
            <Route
              path={`${pathname}/sitemanagerreport`}
              exact={true}
              component={SiteManagerReportContainer} />
            <Route render={() => (<Redirect to={`${pathname}/projects`} />)} />
          </Switch>
        </div>
      </div>
    </div>
  </BrowserRouter>
);

const mapDispatchToProps = dispatch => ({
  onLogoutClick: () =>
    dispatch(logout()),
});

export default connect(
  () => ({}),
  mapDispatchToProps
)(AdminContainer);



// WEBPACK FOOTER //
// ./src/containers/AdminContainer/AdminContainer.js